module.exports = __webpack_public_path__ + "static/media/driver3.f0a233ac.png";